import { DeviceType, DeviceStatus } from "@app/constants";
import * as Yup from "yup";

// Yup validation schema
export const updateDeviceValidationSchema = Yup.object().shape({
  building_name: Yup.string().nullable(),
  device_name: Yup.string().nullable(),
  network_provider: Yup.string().nullable(),
  phone: Yup.string().nullable(),
  status: Yup.string()
    .oneOf(Object.values(DeviceStatus), "Trạng thái không hợp lệ")
    .required("Trạng thái không được để trống"),
  type: Yup.string()
    .oneOf(Object.values(DeviceType), "Trạng thái không hợp lệ")
    .required("Loại không được để trống"),
});
